import React, { useState } from "react";
import fotoPerfilDefault from "../../images/user.png";
import { ApiService } from "../ApiService";

export const ModalSearchClienteH = ({ isOpen, onClose, onUserSelect }) => {
  const API_url = process.env.REACT_APP_API_URL;

  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1); // Índice resaltado

  //STATES DE WILSON
  const [delay_state, setDelay] = useState(null);
  ////////////////////

  const handleSearch = (e) => {
    const value = new String(e.target.value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    setSearchValue(value);

    if (delay_state) {
      clearTimeout(delay_state); // Limpiar el temporizador anterior
    }

    if (value.trim().length < 3) return;

    setDelay(
      setTimeout(async () => {
        if (value.trim().length >= 2) {
          const url = `api/user/search?search_user=${value.replace(" ", "+")}`;
          const options = { method: 'GET' };

          const fetch_request = await ApiService.fetchData(url, options);

          const list_search = fetch_request ? fetch_request : [];
          setSearchResults(list_search);
        } else {
          setSearchResults([]);
        }

        setHighlightedIndex(-1);
      }, 1000)
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setHighlightedIndex((prev) =>
        prev < searchResults.length - 1 ? prev + 1 : prev
      );
    } else if (e.key === "ArrowUp") {
      setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === "Enter" && highlightedIndex !== -1) {
      handleResultClick(searchResults[highlightedIndex]);
    }
  };

  const handleResultClick = (client) => {
    onUserSelect(client);
    setSearchValue("");
    setSearchResults([]);
    setHighlightedIndex(-1);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay-search">
      <div className="modal-content-search">
        <button className="close-modal-btn" onClick={onClose}>
          ✖
        </button>
        <h3 style={{ fontSize: "22px", marginBottom: "10px" }}>Buscar Cliente</h3>

        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Buscar Cliente..."
            value={searchValue}
            onChange={handleSearch}
            onKeyDown={handleKeyDown} // Manejo de teclado
          />
          {searchResults.map((client, index) => (
            <div
              key={client.id}
              className={`search-result-item-user ${index === highlightedIndex ? "highlighted" : ""
                }`}
              onClick={() => handleResultClick(client)}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px",
                borderBottom: "1px solid #ddd",
                cursor: "pointer",
                backgroundColor: index === highlightedIndex ? "#f0f0f0" : "white",
              }}
            >
              <img
                className="photo-perfil-search-user"
                src={client.perfil ? API_url + client.perfil : fotoPerfilDefault}
                alt="Foto de Perfil"
                style={{ width: "30px", height: "30px", marginRight: "10px" }}
              />
              <span className="text-perfil-search">{client.fullName}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
